import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { stringify } from 'querystring';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AppComponent } from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
declare var $: any;
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
export interface NoticeCaseStatus {
  NoticeStatus: string;
  ConvertinCase: string;
}
export interface CaseNotice {
  ID: number;
  refno: string;
  type: string;
  NoticeDt: any;
}
export class UpdateDiary {
  id: number;
  NoticeID: number;
  Type: any;
  fileSize: string;
  fileName: string;
  fileBase = [];
  followDate: string;
  InHour: string;
  InMin: string;
  OutHour: string;
  OutMin: string;
  ActionType: Int16Array;
  ActionTaken: string;
  DiaryPlanDate: string;
  PlanInHour: string;
  PlanInMin: string;
  DiaryPlanActionType: number;
  DiaryPlanActionfor: number;
  DiaryPlanDescription: string;
  AlertTime: any;
}

@Component({
    selector: 'app-update-diary',
    templateUrl: './update-diary.component.html',
    styleUrls: ['./update-diary.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class UpdateDiaryComponent implements OnInit {
  DiaryId: any;
  url: string;
  FormUpdateDiary: FormGroup;
  TypeLink: any;
  PlanDate: any;
  PlanTime: any;
  PreFollowUPID: any;
  CloseDiaryHeader: any;
  PlanActionType: any;
  PlanofActionFor: any;
  PlanDescription: any;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2030, 0, 1);
  fileurls = [];
  dtColumns = [];
  fileSize: string;
  fileName: string;
  Noticeid: number;
  editable: boolean;
  Type: any;
  TypeID: any;
  contextID: any;
  CloseDiaryContextId: string;
  RightsID: string;
  Manager: any;
  pageurl: string;
  planActionType: any;
  FollowUpAction: any;
  HideButtonSubmit: string;
  NoticeCaseStatus: string;
  bindData: any;
  SelectedCaseNotice: number;
  CaseNoticeList: CaseNotice[] = [];
  DiaryData: any;
  RouteGMActionType: string;
  RouteGMPlanActionType: string;
  RouteUserMaster: string;
  UpdateDiary: string;
  DiaryStatus: string;
  CloseCaption: string;
  CaptionAlreadyDone: string;
  UpdateCaption: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  hours: { value: string; label: string; }[];
  minutes: { value: string; label: string; }[];
  isPlanRequired: boolean = false;
  // tslint:disable-next-line: max-line-length
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, public datepipe: DatePipe, protected alertService: AlertService) {
    this.url = AppComponent.baseURL;
    this.hours = Array.from({ length: 24 }, (_, i) => ({ value: i.toString().padStart(2, '0'), label: i.toString().padStart(2, '0') }))
    this.minutes = Array.from({ length: 60 }, (_, i) => ({ value: i.toString().padStart(2, '0'), label: i.toString().padStart(2, '0') }))
  }

  ngOnInit() {
    this.CloseCaption = "Close Diary";
    this.CaptionAlreadyDone = "Diary Already Done";
    this.UpdateCaption = "Update Diary";
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202024001') || this.RightsID.includes('202024021') || this.RightsID.includes('202024000')) {
    } else {
      window.location.href = "module/0";
    }
    // tslint:disable-next-line: max-line-length
    this.RouteGMActionType = this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021') ? 'general-master/055' : 'module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteGMPlanActionType = this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021') ? 'general-master/060' : 'module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteUserMaster = this.RightsID.includes('202040000') || this.RightsID.includes('202040001') || this.RightsID.includes('202040021') ? 'user-master' : 'module/0';
    this.http.get(this.url + 'GM/GetEmployee').subscribe((data) => {
      this.Manager = JSON.parse(data.toString());
    });
    this.getMaster('060', '').subscribe((data: any) => { this.planActionType = data; });
    // 55 = Follow up action
    this.getMaster('055', '').subscribe((data: any) => { this.FollowUpAction = data; });
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.Noticeid = +pagehead[2];
    this.contextID = pagehead[3];
    this.CloseDiaryContextId = pagehead[3];
    this.Type = pagehead[4];
    if (this.CloseDiaryContextId.toString().toUpperCase() == "CLOSEDIARYCASE") {
      this.contextID = 1;
      this.CloseDiaryHeader = 1;
      this.CloseCaption = "Close Case";
      this.CaptionAlreadyDone = "Case Already Done";
      this.UpdateCaption = "Update Case";
    }
    if (this.CloseDiaryContextId.toString().toUpperCase() == "CLOSEDIARYNOTICE") {
      this.CloseDiaryHeader = 1;
      this.CloseCaption = "Close Notice";
      this.CaptionAlreadyDone = "Notice Already Done";
      this.UpdateCaption = "Update Notice";
    }
    if (this.contextID > 0) {
      if (this.Type == 1) {
        this.http.get(this.url + 'CorporateDecision/Fetch_PlanningStatus_Convert?PlanningID=' + this.Noticeid)
          .subscribe((data) => {
            if (data == null) {
            } else {
              this.HideButtonSubmit = "!isHidden";
            }
          }
          );
      }
      if (this.Type == 0 || this.Type == 2) {
        this.http.get(this.url + 'Notice/Fetch_Notice_Case_Status?id=' + this.Noticeid)
          .subscribe((data) => {
            if (data == null) {
            } else {
              const noticeCaseStatus: NoticeCaseStatus = JSON.parse(data.toString())[0];
              this.NoticeCaseStatus = noticeCaseStatus.NoticeStatus;
              if (this.NoticeCaseStatus == "1") {
                this.HideButtonSubmit = "!isHidden";
              }
            }
          }
          );
      }
    }
    if (this.Type == 0 || this.Type == 2) { this.TypeID = 0; } else {
      this.TypeID = 1;
    }
    this.FetchHelpCaseNotice();
    this.FetchDiaryPlan();
    // this.FormUpdateDiary = this.formBuilder.group({
    //   FollowDate: ['', Validators.required], InTime: ['', Validators.required], OutTime: ['', Validators.required], ActionType: [null], ActionTaken: ['', Validators.required], followupFiles: [''],
    //   DiaryPlanDescription: ['', Validators.required], DiaryPlanDate: ['', Validators.required], planInTime: ['', Validators.required], DiaryPlanActionType: ['', Validators.required], DiaryPlanActionfor: [null],
    //   DiaryPlanActionforp: [{ value: 0, disabled: true },Validators.required], DiaryPlanActionTypep: [{ value: 0, disabled: true },Validators.required],
    //   drpCaseNotice: [{ value: this.Noticeid, disabled: true },Validators.required], AlertTime: ['', Validators.required], ContextType: [{ value: +this.Type, disabled: true },Validators.required]
    // });
    this.FormUpdateDiary = this.formBuilder.group({
      // ---- Mandatory always ----
      FollowDate: ['', Validators.required],
      InTime: ['', Validators.required],
      OutTime: ['', Validators.required],
      ActionType: [null],
      ActionTaken: ['', Validators.required],
      followupFiles: [''],
      Remarks: [''],

      // ---- Plan-up (optional initially) ----
      DiaryPlanDescription: [''],
      DiaryPlanDate: [''],
      planInTime: [''],
      DiaryPlanActionType: [''],
      DiaryPlanActionfor: [null],
      AlertTime: [''],

      // ---- Disabled / system fields ----
      DiaryPlanActionforp: [{ value: 0, disabled: true }],
      DiaryPlanActionTypep: [{ value: 0, disabled: true }],
      drpCaseNotice: [{ value: this.Noticeid, disabled: true }],
      ContextType: [{ value: +this.Type, disabled: true }]
    });

    this.FormUpdateDiary.patchValue({
     PlanActionType: "0",
      DiaryPlanActionType: null, ActionType: null, AlertTime: "0", DiaryPlanActionfor: +localStorage.getItem('LoginUserID')
    });



  }
  get f () { return this.FormUpdateDiary.controls; }

  private planUpControls = [
    'DiaryPlanDate',
    'planInTime',
    'DiaryPlanActionType',
    'DiaryPlanActionfor',
    'DiaryPlanDescription',
    'AlertTime'
  ];
  enablePlanUpValidators(): void {
    this.planUpControls.forEach(controlName => {
      const control = this.FormUpdateDiary.get(controlName);
      control?.setValidators([Validators.required]);
      control?.updateValueAndValidity();
    });
  }
  disablePlanUpValidators(): void {
    this.planUpControls.forEach(controlName => {
      const control = this.FormUpdateDiary.get(controlName);
      control?.clearValidators();
      control?.setValue(null);
      control?.updateValueAndValidity();
    });
  }

  onPlanToggle(isPlanRequired: boolean): void {
    this.isPlanRequired = isPlanRequired;
    if (isPlanRequired) {
      this.enablePlanUpValidators();
    } else {
      this.disablePlanUpValidators();
    }
  }

  onChangeContextType(GetContextType) {
    this.Type = GetContextType;
    this.FetchHelpCaseNotice();
  }
  FetchDiaryPlan() {

    this.http.get(this.url + 'Notice/FetchPlanDiary?DiaryID=' + this.contextID)
      .subscribe((data) => {
        if (data == null) { } else {
          this.DiaryData = JSON.parse(data.toString())[0];
          this.PlanDate = this.DiaryData.PlanDate;
          this.PlanDescription = this.DiaryData.PlanDescr;
          this.PlanTime = this.DiaryData.PlanInTimeHR + ':' + this.DiaryData.PlanInTimeMin;
          this.PreFollowUPID = this.DiaryData.FollowUpID;
          this.FormUpdateDiary.patchValue({
            DiaryPlanActionforp: this.DiaryData.ResponsibleUserID,
            DiaryPlanActionTypep: this.DiaryData.PlanType
          });

          // let latest_date = this.datepipe.transform(NoticeDiary.PlanDate, 'yyyy-MM-dd');
          // this.PlanForForm.patchValue({
          //     InHour: NoticeDiary.PlanInTimeHR, InMin: NoticeDiary.PlanInTimeMin, PlanActionType: NoticeDiary.PlanType,
          //     PlanActionfor: NoticeDiary.ResponsibleUserID, AlertTime: NoticeDiary.AlertTime, AlertType: NoticeDiary.AlertValue,
          //     PlanDate: latest_date, PlanDescription: NoticeDiary.PlanDescr});
        }
      }
      );
  }
  FetchHelpCaseNotice() {
    if (this.Type == 0 || this.Type == 4) {
      this.TypeID = 0;
      this.bindData = 'Help/FetchHelpRefNoNotice?id=' + this.Noticeid;
    } else if (this.Type == 1) {
      this.TypeID = 1;
      this.bindData = 'Help/FetchHelpRefNoPlanning?id=' + this.Noticeid;
    } else if (this.Type == 2) {
      this.TypeID = 0;
      this.bindData = 'Help/FetchHelpRefNoCase?id=' + this.Noticeid;
    }

    this.http.get(this.url + this.bindData)
      .subscribe((data) => {
        if (data == null) {
          this.CaseNoticeList = null;
        } else {
          this.CaseNoticeList = JSON.parse(data.toString());
          if (this.Noticeid > 0) {
            this.SelectedCaseNotice = this.Noticeid;
          }
          if (this.Type == 4) {
            this.FormUpdateDiary.patchValue({ ContextType: 0 });
          } else {
            this.FormUpdateDiary.patchValue({ ContextType: +this.Type });
          }
        }
      }
      );
  }
  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
      .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }

  onHeaderSubmit(UpdateFormControl) {
    if (this.FormUpdateDiary.invalid) {
      this.FormUpdateDiary.markAllAsTouched();
      return;
    }
    // if (UpdateFormControl.FollowDate == "") {
    //   this.alertService.showWarning('Please Enter Date');
    //   return;
    // }
    // if (UpdateFormControl.ActionType == 0) {
    //   this.alertService.showWarning('Please Select Action Type');
    //   return;
    // }
    // if (UpdateFormControl.ActionTaken == "") {
    //   this.alertService.showWarning('Please Enter Action Taken');
    //   return;
    // } else {
      // tslint:disable-next-line: max-line-length
      // if (UpdateFormControl.DiaryPlanActionType != 0 || UpdateFormControl.DiaryPlanDescription != "") {
      //   if (UpdateFormControl.DiaryPlanDate == "") { this.alertService.showWarning('Please Enter Plan Date'); return; }
      //   if (UpdateFormControl.DiaryPlanActionType == 0) { this.alertService.showWarning('Please Select Plan Action Type'); return; }
      //   if (UpdateFormControl.DiaryPlanDescription == "") { this.alertService.showWarning('Please Enter Plan Description'); return; }
      // }
      if (this.CloseDiaryContextId == 'CloseDiaryNotice' || this.CloseDiaryContextId == 'CloseDiaryCase') {
          // if (this.CloseDiaryContextId.toString().toUpperCase() == "CLOSEDIARYCASE") {
            this.http.get(this.url + 'Notice/CloseReworkNoticeCase?id=' + this.Noticeid + '&status=1')
              .subscribe((data) => {
                if (data == null) {
                } else {
                  this.ngOnInit();
                  this.alertService.showSuccess("Successfully Closed");
                }
              }
              );
          // }
      }else{
        let UD: UpdateDiary = {
          id: this.contextID,
          NoticeID: this.Noticeid,
          Type: this.TypeID,
          fileSize: this.fileSize,
          fileName: this.fileName,
          fileBase: this.fileurls,
          followDate: UpdateFormControl.FollowDate,
          InHour: UpdateFormControl.InTime.split(':')[0],
          InMin: UpdateFormControl.InTime.split(':')[1],
          OutHour: UpdateFormControl.OutTime.split(':')[0],
          OutMin: UpdateFormControl.OutTime.split(':')[1],
          ActionType: UpdateFormControl.ActionType,
          ActionTaken: UpdateFormControl.ActionTaken,
          DiaryPlanDate: null,
          PlanInHour: null,
          PlanInMin: null,
          DiaryPlanActionType: null,
          DiaryPlanActionfor: null,
          DiaryPlanDescription: '',
          AlertTime: null
        };
        if (this.isPlanRequired) {
          UD.DiaryPlanDate = UpdateFormControl.DiaryPlanDate;
          UD.PlanInHour = UpdateFormControl.planInTime.split(':')[0];
          UD.PlanInMin = UpdateFormControl.planInTime.split(':')[1];
          UD.DiaryPlanActionType = UpdateFormControl.DiaryPlanActionType;
          UD.DiaryPlanActionfor = UpdateFormControl.DiaryPlanActionfor;
          UD.DiaryPlanDescription = UpdateFormControl.DiaryPlanDescription;
          UD.AlertTime = UpdateFormControl.AlertTime;
        };
        this.http.post(this.url + 'Notice/UpdateDiary', UD).subscribe((data) => {
          if (data == null) {
            this.alertService.showError('Diary Not Submited');
          } else {
            this.alertService.showSuccess('Diary Submitted');
            window.history.back();
          }
        }
        );
      }


    // }

  }
  // For Get Fact Sheet Files in Base64 format
  onSelectFile(event) {
    this.fileurls = [];
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      this.fileName = '';
      this.fileSize = '';
      for (let i = 0; i < filesAmount; i++) {
        this.fileName += event.target.files[i].name + ',';
        this.fileSize += event.target.files[i].size + ',';
        // tslint:disable-next-line: prefer-const
        let reader = new FileReader();
        // tslint:disable-next-line: no-shadowed-variable
        reader.onload = (event: any) => { this.fileurls.push(event.target.result); };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }
  goBack() {
    window.history.back();
  }
}
